// extracted by mini-css-extract-plugin
module.exports = {"logos":"FooterLogos_logos__l2Bdf","logo":"FooterLogos_logo__243aK"};